import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const STATUS_MAP = {
    "new": { cls: "sbadge--new", label: "New" },
    "issued": { cls: "sbadge--issued", label: "Issued" },
    "in_progress": { cls: "sbadge--in-progress", label: "In progress" },
    "partial": { cls: "sbadge--partial", label: "Partial" },
    "pending_approval": { cls: "sbadge--pending", label: "Pending approval" },
    "complete": { cls: "sbadge--complete", label: "Complete" },
    "expired": { cls: "sbadge--expired", label: "Expired" },
    "cancelled": { cls: "sbadge--cancelled", label: "Cancelled" },
    "failed": { cls: "sbadge--failed", label: "Failed" },
};
export default function StatusBadge({ status }) {
    const def = STATUS_MAP[status]
        ?? { cls: "sbadge--muted", label: status };
    return (_jsxs("span", { className: `sbadge ${def.cls}`, children: [_jsx("span", { className: "dot" }), def.label] }));
}
//# sourceMappingURL=StatusBadge.js.map